import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/authApi'
import type { ApiError } from '@/types/api'
import type { UpdatePasswordData } from '../schema/passwordSchema'
import { toast } from '@/integrations/toaster-provider'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdatePasswordMutation = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: UpdatePasswordData) =>
      authApi.updatePassword({
        currentPassword,
        newPassword,
      }),
    onSuccess: () => {
      toast.success('Password updated successfully')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to update password')
    },
  })
}
